import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { globalContext } from './modules/analytics/constants';
import analytics from 'modules/analytics';
import useInterval from 'react-use/esm/useInterval';
import { worklistAutoLoadState } from 'domains/worklist/Worklist/state';

// avoiding use of a name like `DatadogSharedContextProvider` to avoid
// being confused with React.Context
export function DatadogSharedContextApplier(): React.ReactElement | null {
  useQuotaMonitoring();
  useWorklistAutoLoadContext();

  return null;
}

function useWorklistAutoLoadContext() {
  const { surface } = useRecoilValue(worklistAutoLoadState);

  useEffect(() => {
    analytics.addContext(globalContext.worklistSettings.autoLoad, {
      enabled: surface != null,
      surface: surface ?? null,
    });
  }, [surface]);
}

const QUOTA_MONITORING_INTERVAL_MS = 15000;

function useQuotaMonitoring() {
  monitorQuota();
  useInterval(monitorQuota, QUOTA_MONITORING_INTERVAL_MS);
}

async function monitorQuota() {
  const storageEstimate = await navigator?.storage.estimate();
  if (storageEstimate == null) {
    return;
  }

  analytics.addContext(globalContext.workspace.storageEstimate, {
    ...storageEstimate,
    percentUsed:
      storageEstimate.usage != null && storageEstimate.quota != null
        ? storageEstimate.quota === 0
          ? 1
          : storageEstimate.usage / storageEstimate.quota
        : 0,
  });
}
